import type { RouteRecordRaw } from 'vue-router'

const sessionReportsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings/user-activity-reports',
    name: 'activity-reports.index',
    component: () => import('@/modules/user/session-reports/views/SessionReportsIndex.vue'),
    meta: {
      pageTitle: 'User Activity Reports',
      breadcrumbs: ['Settings', 'User Activity Reports']
    }
  },
  {
    path: '/settings/user-activity-reports/:id',
    name: 'activity-reports.user',
    component: () => import('@/modules/user/session-reports/views/SessionReportsUser.vue'),
    meta: {
      pageTitle: 'User Activity Report',
      breadcrumbs: ['Settings', 'User Activity Reports']
    }
  }
]

export default sessionReportsRoutes
